import React from 'react';
import {TabView} from '../../../components/tab';
import {ReferralClosedGroupTable, ReferralTable} from './ReferralTable';
import {useFilter} from '@unthinkable/react-filters';
import {GroupFilter, SearchFilter} from '../../../components/filter/Filters';
import {Button} from '../../../components/button/Button';
import {useAppStateContext} from '../../../providers/AppState';

export const ReferralTabs = props => {
  const {searchValue, onChangeFilter, filterValues, applyFilter} = useFilter();
  const {download} = useAppStateContext();
  const tabs = {
    open: {
      label: 'Open',
      view: (
        <ReferralTable
          {...props}
          addOnFilter={{
            added_to_job_opening: {
              $in: [null, false],
            },
            status: {
              $nin: ['Rejected'],
            },
            ...filterValues?.filter,
          }}
        />
      ),
      api: '/referralCandidates',
      filter: {
        added_to_job_opening: {
          $in: [null, false],
        },
        status: {
          $nin: ['Rejected'],
        },
        ...filterValues?.filter,
      },
      eventSourceId: 'ReferralCandidate',
      search: searchValue,
      searchFields: ['name', 'email'],
      actions: [
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              label: 'Job Opening',
              field: 'job_opening',
              api: '/jobOpenings',
              type: 'autoComplete',
              suggestionField: 'position_title.name',
              getDisplayValue: ({value}) => value?.position_title?.name,
              placeholder: 'Position',
              fields: {
                position_title: {
                  name: 1,
                },
              },
            },
            {
              label: 'Status',
              field: 'status',
              options: [
                {label: 'Added', value: 'Closed'},
                {label: 'Rejected', value: 'Rejected'},
              ],
              type: 'autoComplete',
              suggestionField: 'label',
              valueField: 'label',
              keyField: 'value',
            },
          ]}
        />,
      ],
    },
    closed: {
      label: 'Closed',
      view: (
        <ReferralClosedGroupTable
          {...props}
          addOnFilter={{
            $or: [
              {added_to_job_opening: true},
              {
                status: 'Rejected',
              },
            ],
            ...filterValues?.filter,
          }}
        />
      ),
      api: '/referralCandidates',
      filter: {
        $or: [
          {added_to_job_opening: true},
          {
            status: 'Rejected',
          },
        ],
        ...filterValues?.filter,
      },
      eventSourceId: 'ReferralCandidate',
      search: searchValue,
      searchFields: ['name', 'email'],
      actions: [
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              label: 'Job Opening',
              field: 'job_opening',
              api: '/jobOpenings',
              type: 'autoComplete',
              suggestionField: 'position_title.name',
              getDisplayValue: ({value}) => value?.position_title?.name,
              placeholder: 'Position',
              fields: {
                position_title: {
                  name: 1,
                },
              },
            },
            {
              label: 'Status',
              field: 'status',
              options: [
                {label: 'Added', value: 'Closed'},
                {label: 'Rejected', value: 'Rejected'},
              ],
              type: 'autoComplete',
              suggestionField: 'label',
              valueField: 'label',
              keyField: 'value',
            },
            {
              label: 'Closed Date',
              field: 'closed_date',
              type: 'date',
            },
          ]}
        />,
        <Button
          text="Download"
          onPress={async () => {
            await download({
              uri: `/exportExcelHelper`,
              props: {
                props: {
                  fetchProps: {
                    api: '/referralCandidates',
                    params: {
                      ...props.params,
                      ...filterValues.params,
                    },
                    addOnFilter: filterValues?.filter,
                    search: searchValue,
                    searchFields: ['name', 'email'],
                  },
                  column: {
                    Name: 'name',
                    Email: 'email',
                    'Reffred On': 'createdAt',
                    'Job Opening': 'job_opening.position_title.name',
                    'Reffered By': 'referred_by.name',
                    'Reffered by Email': 'referred_by.official_email_id',
                    'Refferal Status': 'status',
                    'Candidate Status ': 'candidate.status',
                  },
                },
              },
            });
          }}
        />,
      ],
    },
  };
  return (
    <TabView
      tabs={tabs}
      search={searchValue}
      searchFields={['name', 'email']}
      actions={[
        <SearchFilter
          onChangeFilter={onChangeFilter}
          searchValue={searchValue}
          placeholder="Search Candidate"
        />,
      ]}
    />
  );
};
